import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
const navLinks = [{
  label: 'Program de Grup',
  href: 'https://psihomedicina.ro/start'
}, {
  label: 'Cursuri Online',
  href: 'https://psihomedicina.ro/fitoterapie'
}, {
  label: 'Sesiune Cadou',
  href: 'https://api.leadconnectorhq.com/widget/bookings/cmi-dr-cornelia-tianu-39b19d4e-46bc-4f77-b746-6d1dddacfb09'
}, {
  label: 'Despre Mine',
  href: 'https://psihomedicina.ro/despre'
}, {
  label: 'Blog',
  href: 'https://psihomedicina.ro/blog'
}];
export function Navbar() {
  const [open, setOpen] = useState(false);
  return <nav className="bg-white/90 backdrop-blur-md fixed top-0 left-0 right-0 z-50 border-b border-soft/50 shadow-sm" data-id="element-166" data-mp="ekz4sy7r0yne">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-167" data-mp="9me28s50y2vs">
        <div className="flex items-center justify-between h-16" data-id="element-168" data-mp="1pxi3udo411u2">
          {/* Logo */}
          <a href="https://psihomedicina.ro/" className="flex items-center" data-id="element-169" data-mp="1l09glyo3u7ly">
            <img src="https://cdn.magicpatterns.com/uploads/uHbK1QXv8cqZk8wKkAy8Rh/Screenshot_2026-04-19_at_00.13.33.png" alt="Academia de PsihoMedicină" className="h-12 object-contain" data-id="element-170" data-mp="9opwdbkkul1n" />
          </a>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-6" data-id="element-171" data-mp="olqeqogvp3ng">
            {navLinks.map(link => <a key={link.label} href={link.href} className="text-body hover:text-primary transition-colors text-sm font-medium" data-id="element-172" data-mp="3n3dyt186a171">
                {link.label}
              </a>)}
            <a href="https://psihomedicina.app.clientclub.net/courses/library-v2" className="bg-primary text-white font-semibold rounded-full px-5 py-2 text-sm hover:bg-medium transition-colors shadow-md" data-id="element-173" data-mp="ul20i68irhd">
              Autentificare
            </a>
          </div>

          {/* Mobile menu button */}
          <button onClick={() => setOpen(!open)} className="md:hidden p-2 text-body hover:text-primary transition-colors" aria-label="Toggle menu" data-id="element-174" data-mp="31b9qy7j04jxr">
            {open ? <X className="w-6 h-6" data-id="element-175" data-mp="3b0tevrlkn3zh" /> : <Menu className="w-6 h-6" data-id="element-176" data-mp="3b01gk90las5i" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && <div className="md:hidden bg-white border-t border-soft/50 px-4 pb-4 relative z-[60]" data-id="element-177" data-mp="362rv14gbn0my">
          <div className="flex flex-col gap-3 pt-3" data-id="element-178" data-mp="2icxgmigct40l">
            {navLinks.map(link => <a key={link.label} href={link.href} className="block text-body hover:text-primary transition-colors font-medium py-3 px-2" data-id="element-179" data-mp="2devol80y9ucz">
                {link.label}
              </a>)}
            <a href="https://psihomedicina.app.clientclub.net/courses/library-v2" className="block bg-primary text-white font-semibold rounded-full px-5 py-3 text-center hover:bg-medium transition-colors shadow-md mt-2" data-id="element-180" data-mp="7jun0vbw2bag">
              Autentificare
            </a>
          </div>
        </div>}
    </nav>;
}